let api_base_url = process.env.REACT_APP_API_BASE_URL;
let api_base_url_v8 = process.env.REACT_APP_API_BASE_URL;

if (window.location.hostname === "dev.portal.quranflow.org") {
  // Dev
    api_base_url = "https://dev.api.quranflow.org/v8/";
    api_base_url_v8 = "https://dev.api.quranflow.org/v8/";
} else if (window.location.hostname !== "localhost") {
    // Production
    api_base_url = "https://api.quranflow.org/v8/";
    api_base_url_v8 = "https://api.quranflow.org/v8/";
}

const config = {
    api_base_url,
    api_base_url_v8,
};

export default config;
